<div class="py-6 flex flex-col justify-center sm:py-12">
  <div class="w-3/4 py-4 px-8 mx-auto bg-white shadow-xl rounded-lg my-20">
    <div class="flex justify-center md:justify-end -mt-16">
      <img class="w-20 h-20 object-cover rounded-full border-2 border-indigo-500"
        src="../../../assets/img/fusilli_header_dummy.jpg">
    </div>
    <div class="text-center">
      <h2>Add new showcase</h2>
      <p class="mt-2 text-gray-600 text-justify">
        This platform gathers innovative food policies and practices in cities worldwide, which are presented in the
        form of showcases. A showcase can contain both basic and in-depth information about food policies and practices.
        In this way, the experiences and expertise of showcases can be shared and compared, while being understood from
        their local contexts.
        <br><br>
        <span class="text-center">On this page, you can add a showcase by filling out the form below.</span>
      </p>
    </div>
  </div>
  <!-- Basic -->
  <div class="mx-4">
    <div class="md:grid md:grid-cols-4 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Basic Information</h3>
          <p class="text-justify text-sm mt-3 text-gray-500 italic">*Here you can fill out some basic information about
            the food policy,
            practice, activity or event that you
            would like to add to the database.</p>
        </div>
      </div>

      <div class="mt-5 md:mt-0 md:col-span-3">
        <div>
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
              <!-- Title -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Title
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input type="text" [(ngModel)]="title"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. Your Title">
                  </div>
                </div>
              </div>

              <!-- Keywords -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Keywords
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input type="text" [(ngModel)]="keywords"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. Ecological, Organization">
                  </div>
                </div>
              </div>

              <!-- Summary -->
              <div>
                <label for="about" class="block text-sm font-medium text-gray-700">
                  Summary
                </label>
                <p class="text-justify text-xs mt-3 text-red-300 italic">*Please write a 2 to 3 sentence summary of what
                  the showcase is
                  about.</p>
                <div class="mt-1">
                  <quill-editor [modules]="QuillConfiguration" [(ngModel)]="summary"
                    class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    placeholder="Your Summary"></quill-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900"></h3>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-3">
        <div>
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
              <!-- Country -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Country
                  </label>
                  <p class="text-justify text-xs mt-3 text-red-300 italic">*Filling in the country is required – it
                    allows us to show the
                    showcase on the map.</p>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <select [(ngModel)]="country" [ngModelOptions]="{standalone: true}"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-white"
                      id="country">
                      <option value="" disabled selected>Select a country</option>
                      <option *ngFor="let nation of countries" [value]="nation.code">{{ nation.name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- City -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    City or region where the showcase is located
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input type="text" [(ngModel)]="city" [ngModelOptions]="{standalone: true}"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. Athens">
                  </div>
                </div>
              </div>

              <!-- Zip Code -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Zip Code
                  </label>
                  <p class="text-justify text-xs mt-3 text-red-300 italic">*Filling in the zip code is required – it
                    allows us to show the
                    showcase on the map.</p>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input type="text" [(ngModel)]="zip" [ngModelOptions]="{standalone: true}"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. 101801">
                  </div>
                </div>
              </div>

              <!-- City population -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    City/Region Population
                  </label>
                  <p class="text-justify text-xs mt-3 text-red-300 italic">*.Give an estimation of the population of the
                    city or region
                    where the food practice takes place.</p>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input type="number" [(ngModel)]="cityPopulation" [ngModelOptions]="{standalone: true}"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. 200,000">
                  </div>
                </div>
              </div>

              <!-- Duration -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Year of implementation
                  </label>
                  <p class="mt-2 text-xs text-red-300 italic">
                    *Year field needs to be filled and is a number!
                  </p>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input type="number" [(ngModel)]="durationFrom"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-1/3 rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. 2022">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--  Overview -->
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200"></div>
    </div>
  </div>

  <div class="mt-10 sm:mt-0 mx-4">
    <div class="md:grid md:grid-cols-4 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Overview of Initiative</h3>
          <p class="text-justify text-sm mt-3 text-gray-500 italic">* Here you can write more in-depth on the food
            policy, practice, activity
            or event. You are invited to summarize what the showcase is about and how it has been operating so far.
            Also, we are interested in the local, regional and/or global barriers that the showcase tackles, but also in
            the challenges that the showcase is still facing.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-3">
        <div>
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">

              <!-- Overview -->
              <div>
                <label for="about" class="block text-sm font-medium text-gray-700">
                  Overview
                </label>
                <div class="mt-1">
                  <quill-editor [modules]="QuillConfiguration" [(ngModel)]="overview"
                    class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    placeholder="Your Overview"></quill-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Concrete Actions  -->
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200"></div>
    </div>
  </div>

  <div class="mt-10 sm:mt-0 mx-4">
    <div class="md:grid md:grid-cols-4 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Concrete Actions</h3>
          <p class="text-justify text-sm mt-3 text-gray-500 italic">*‘Concrete Actions’ refer to the more
            specific or targeted
            actions that are undertaken in a showcase. For example, a part of a city’s food strategy might be
            stakeholder engagement, and in this section the particular and methods can be described of how stakeholders
            are participating in the city’s food strategy. Another example could be a food cooperative in which people
            collectively buy organic and local produce to lower the price. Distinct implementation activities might be
            1) the way in which the cooperative members collaborate, 2) how they organize their food waste, 3) how they
            communicate with local food producers from which they buy their food.
            <br><br>
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-3">
        <div>
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6" *ngFor="let implementation of implementations">

              <!-- Activity -->
              <div>
                <label for="about" class="block text-sm font-medium text-gray-700">
                  Actions
                </label>
                <div class="mt-1">
                  <quill-editor [modules]="QuillConfiguration" [(ngModel)]="implementation.content"
                    class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    placeholder="Your Content"></quill-editor>
                </div>
              </div>

            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button (click)="addIA()" type="submit"
                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Add more
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Multi-Objective Approach -->
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200"></div>
    </div>
  </div>

  <div class="mt-10 sm:mt-0 mx-4">
    <div class="md:grid md:grid-cols-4 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Lessons Learned</h3>
          <p class="text-justify text-sm mt-3 text-gray-500 italic">
            *A key topic of interest is the way in which showcases address multiple types of lessons learned in regards
            to: food governance, food production, food distribution, food consumption, food waste, and social
            and economic equality throughout the food chain.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-3">
        <div>
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6" *ngFor="let multi of multis">

              <!-- Title -->
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Title
                  </label>
                  <div class="mt-1 flex rounded-md shadow-sm">
                    <input [(ngModel)]="multi.title" [ngModelOptions]="{standalone: true}" type="text"
                      class="h-8 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-md sm:text-sm border-gray-300"
                      placeholder="e.g. Your Title">
                  </div>
                </div>
              </div>

              <!-- Summary -->
              <div>
                <label for="about" class="block text-sm font-medium text-gray-700">
                  Summary
                </label>
                <div class="mt-1">
                  <quill-editor [modules]="QuillConfiguration" [(ngModel)]="multi.summary"
                    class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    placeholder="Your Summary"></quill-editor>
                </div>
              </div>

              <!-- Explanation -->
              <div>
                <label for="about" class="block text-sm font-medium text-gray-700">
                  Explanation
                </label>
                <div class="mt-1">
                  <quill-editor [modules]="QuillConfiguration" [(ngModel)]="multi.content"
                    class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    placeholder="Your Content"></quill-editor>
                </div>
              </div>

            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button (click)="addMoa()" type="submit"
                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Add more
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- References -->
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200"></div>
    </div>
  </div>

  <div class="mt-10 sm:mt-0 mx-4">
    <div class="md:grid md:grid-cols-4 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Links</h3>
          <p class="text-justify text-sm mt-3 text-gray-500 italic">
            *Add links for references.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-3">
        <div>
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <label for="company-website" class="block text-sm font-medium text-gray-700">
                    Links
                  </label>
                  <quill-editor [modules]="LinksQuillConfiguration" [(ngModel)]="references"
                    class=" shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    placeholder="Your Links"></quill-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Submit -->
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200"></div>
    </div>
  </div>

  <div class="mt-10 sm:mt-0 text-center">
    <button (click)="onSubmit();" type="submit"
      class="inline-flex justify-center py-2 px-4 border border-transparent shadow-lg text-md font-medium rounded-md text-white bg-pink-800 disabled:bg-pink-400 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      Submit Document
    </button>
  </div>

  <swal>
  </swal>

</div>